import { Typography } from "antd";
import { useNavigate } from "react-router-dom";
import "./userDetails.css";

const UserSetting = ({
  setOpenSetting,
}: {
  setOpenSetting: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const navigate = useNavigate();
  return (
    <div className={"user-setting"}>
      <div
        className="text-setting"
        onClick={() => {
          navigate("/bank"), setOpenSetting(false);
        }}
      >
        <Typography style={{ fontSize: 14, fontWeight: 400, color: "white" }}>
          Banks
        </Typography>
      </div>
      <div
        className="text-setting"
        onClick={() => {
          if(process.env.REACT_APP_HELP_LINK) {
            window.open(process.env.REACT_APP_HELP_LINK, "_blank", "noopener,noreferrer")
            setOpenSetting(false)
            return
          }
          navigate("/help"), setOpenSetting(false);
        }}
      >
        <Typography style={{ fontSize: 14, fontWeight: 400, color: "white" }}>
          Help
        </Typography>
      </div>
      <div
        className="text-setting"
        onClick={() => {
          if(process.env.REACT_APP_CONTACT_US_LINK) {
            window.open(process.env.REACT_APP_CONTACT_US_LINK, "_blank", "noopener,noreferrer")
            setOpenSetting(false)
            return
          }
          navigate("/contact-us"), setOpenSetting(false);
        }}
      >
        <Typography style={{ fontSize: 14, fontWeight: 400, color: "white" }}>
          Contact Us
        </Typography>
      </div>
    </div>
  );
};
export default UserSetting;
